import React from 'react';
import { Route, Switch } from 'react-router-dom';
import RouteFallback from './RouteFallback';
import loadable from '@loadable/component';
import RedirectPage from '../Components/RedirectPage';

import { PLAYSTORE_LINK, APPSTORE_LINK } from '../Constants';

const LazyHome = loadable(
  () => import(/* webpackChunkName: "Home" */ '../Pages/Home/index'),
  {
    fallback: <RouteFallback />
  }
);
const LazyPolicy = loadable(
  () =>
    import(/* webpackChunkName: "Policy" */ '../Pages/Policy/PrivacyPolicy'),
  {
    fallback: <RouteFallback />
  }
);
const LazyTOS = loadable(
  () =>
    import(
      /* webpackChunkName: "T&C" */ '../Pages/TermsandConditions/TermsandConditions'
    ),
  {
    fallback: <RouteFallback />
  }
);
const LazyFAQ = loadable(
  () => import(/* webpackChunkName: "FAQ" */ '../Pages/Faq/Faq'),
  {
    fallback: <RouteFallback />
  }
);

const LazyVineAppLinks = loadable(
  () =>
    import(/* webpackChunkName: "vine_app_links" */ '../Pages/AppLinks/Vine'),
  {
    fallback: <RouteFallback />
  }
);

const LazyLLFAppLinks = loadable(
  () =>
    import(
      /* webpackChunkName: "vine_app_links" */ '../Pages/LetLoveFlyApp/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const WeddingAppLinks = loadable(
  () =>
    import(
      /* webpackChunkName: "vine_app_links" */ '../Pages/WeddingApp/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const LazyLLFPolicy = loadable(
  () =>
    import(/* webpackChunkName: "Policy" */ '../Pages/LetLoveFlyPolicy/index'),
  {
    fallback: <RouteFallback />
  }
);
const LazyAsianPaintsPolicy = loadable(
  () =>
    import(/* webpackChunkName: "Policy" */ '../Pages/AsianPaintsPolicy/index'),
  {
    fallback: <RouteFallback />
  }
);

const LazySuperPremiumApplicatorsPolicy = loadable(
  () =>
    import(
      /* webpackChunkName: "Policy" */ '../Pages/SuperPremiumApplicators/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const LazyACPolicy = loadable(
  () =>
    import(
      /* webpackChunkName: "Policy" */ '../Pages/AnkushChinmayaPolicy/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const LazyTMPolicy = loadable(
  () =>
    import(/* webpackChunkName: "Policy" */ '../Pages/TmKaMagicPolicy/index'),
  {
    fallback: <RouteFallback />
  }
);

const LazyDeleteAccount = loadable(
  () =>
    import(/* webpackChunkName: "Policy" */ '../Pages/DeleteAccountPage/index'),
  {
    fallback: <RouteFallback />
  }
);

const TmKaMagicAppLinks = loadable(
  () =>
    import(
      /* webpackChunkName: "vine_app_links" */ '../Pages/TmKaMagicApp/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const EemaAppLinks = loadable(
  () =>
    import(/* webpackChunkName: "vine_app_links" */ '../Pages/EemaApp/index'),
  {
    fallback: <RouteFallback />
  }
);

const IntegrityChampAppLinks = loadable(
  () =>
    import(
      /* webpackChunkName: "vine_app_links" */ '../Pages/IntegrityChampApp/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const LazyPRPolicy = loadable(
  () =>
    import(
      /* webpackChunkName: "Policy" */ '../Pages/PolycabRefreshPolicy/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const MspirePolicy = loadable(
  () => import(/* webpackChunkName: "Policy" */ '../Pages/MspirePolicy/index'),
  {
    fallback: <RouteFallback />
  }
);

const Mspire2025Policy = loadable(
  () =>
    import(/* webpackChunkName: "Policy" */ '../Pages/Mspire2025Policy/index'),
  {
    fallback: <RouteFallback />
  }
);

const Mspire2026Policy = loadable(
  () =>
    import(/* webpackChunkName: "Policy" */ '../Pages/Mspire2026Policy/index'),
  {
    fallback: <RouteFallback />
  }
);

const HCCBPartnersMeet2026Policy = loadable(
  () =>
    import(
      /* webpackChunkName: "Policy" */ '../Pages/HCCBPartnersMeet2026Policy/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const GrowthCodePolicy = loadable(
  () =>
    import(/* webpackChunkName: "Policy" */ '../Pages/GrowthCodePolicy/index'),
  {
    fallback: <RouteFallback />
  }
);

const enGenPolicy = loadable(
  () => import(/* webpackChunkName: "Policy" */ '../Pages/enGenPolicy/index'),
  {
    fallback: <RouteFallback />
  }
);

const LazyenGenAppLinks = loadable(
  () =>
    import(/* webpackChunkName: "vine_app_links" */ '../Pages/enGenApp/index'),
  {
    fallback: <RouteFallback />
  }
);

const LazyHCCBPartnersMeet2026AppLinks = loadable(
  () =>
    import(
      /* webpackChunkName: "vine_app_links" */ '../Pages/HCCBPartnersMeet2026App/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const LazyGrowthCodeAppLinks = loadable(
  () =>
    import(
      /* webpackChunkName: "vine_app_links" */ '../Pages/GrowthCodeApp/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const LazyNirvaanAppLinks = loadable(
  () =>
    import(
      /* webpackChunkName: "vine_app_links" */ '../Pages/NirvaanApp/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const RutwikTanviPolicy = loadable(
  () =>
    import(/* webpackChunkName: "Policy" */ '../Pages/RutwikTanviPolicy/index'),
  {
    fallback: <RouteFallback />
  }
);

const TanviRutwikPolicy = loadable(
  () =>
    import(/* webpackChunkName: "Policy" */ '../Pages/TanviRutwikPolicy/index'),
  {
    fallback: <RouteFallback />
  }
);

const LazyRutwikTanviAppLinks = loadable(
  () =>
    import(
      /* webpackChunkName: "vine_app_links" */ '../Pages/RutwikTanviApp/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const RoadToPhuketPolicy = loadable(
  () =>
    import(
      /* webpackChunkName: "Policy" */ '../Pages/RoadToPhuketPolicy/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const WellnessExpeditionPolicy = loadable(
  () =>
    import(
      /* webpackChunkName: "Policy" */ '../Pages/WellnessExpeditionPolicy/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const LazyWellnessExpeditionAppLinks = loadable(
  () =>
    import(
      /* webpackChunkName: "vine_app_links" */ '../Pages/WellnessExpeditionApp/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const Thryvified2026Policy = loadable(
  () =>
    import(
      /* webpackChunkName: "Policy" */ '../Pages/Thryvified2026Policy/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const TigerAnalyticsPolicy = loadable(
  () =>
    import(
      /* webpackChunkName: "Policy" */ '../Pages/TigerAnalyticsPolicy/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const LazyTigerAnalyticsAppLinks = loadable(
  () =>
    import(
      /* webpackChunkName: "vine_app_links" */ '../Pages/TigerAnalyticsApp/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const APMIAnnualConference2026Policy = loadable(
  () =>
    import(
      /* webpackChunkName: "Policy" */ '../Pages/APMIAnnualConference2026Policy/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const JharokhaSangamPolicy = loadable(
  () =>
    import(
      /* webpackChunkName: "Policy" */ '../Pages/JharokhaSangamPolicy/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const GCOOCONCLAVE2026Policy = loadable(
  () =>
    import(
      /* webpackChunkName: "Policy" */ '../Pages/GCOOCONCLAVE2026Policy/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const SAREX26Policy = loadable(
  () => import(/* webpackChunkName: "Policy" */ '../Pages/SAREX26Policy/index'),
  {
    fallback: <RouteFallback />
  }
);

const GSM26Policy = loadable(
  () => import(/* webpackChunkName: "Policy" */ '../Pages/GSM26Policy/index'),
  {
    fallback: <RouteFallback />
  }
);

const LazyGSM26AppLinks = loadable(
  () =>
    import(/* webpackChunkName: "vine_app_links" */ '../Pages/GSM26App/index'),
  {
    fallback: <RouteFallback />
  }
);

const LazySAREX26AppLinks = loadable(
  () =>
    import(
      /* webpackChunkName: "vine_app_links" */ '../Pages/SAREX26App/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const LazyGCOOCONCLAVE2026AppLinks = loadable(
  () =>
    import(
      /* webpackChunkName: "vine_app_links" */ '../Pages/GCOOCONCLAVE2026App/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const LazyJharokhaSangamAppLinks = loadable(
  () =>
    import(
      /* webpackChunkName: "vine_app_links" */ '../Pages/JharokhaSangamApp/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const LazyAPMIAnnualConference2026AppLinks = loadable(
  () =>
    import(
      /* webpackChunkName: "vine_app_links" */ '../Pages/APMIAnnualConference2026App/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const LazyRoadToPhuketAppLinks = loadable(
  () =>
    import(
      /* webpackChunkName: "vine_app_links" */ '../Pages/RoadToPhuketApp/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const RedKkarpetEventsPolicy = loadable(
  () =>
    import(
      /* webpackChunkName: "Policy" */ '../Pages/RedKkarpetEventsPolicy/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const RedKkarpetEventsAppLinks = loadable(
  () =>
    import(
      /* webpackChunkName: "vine_app_links" */ '../Pages/RedKkarpetEventsApp/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const LMAIPolicy = loadable(
  () => import(/* webpackChunkName: "Policy" */ '../Pages/Lmai/index'),
  {
    fallback: <RouteFallback />
  }
);

const VibeWithTheNightPolicy = loadable(
  () =>
    import(
      /* webpackChunkName: "Policy" */ '../Pages/VibeWithTheNightPolicy/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const LazyRGPolicy = loadable(
  () =>
    import(/* webpackChunkName: "Policy" */ '../Pages/RidomilGoldPolicy/index'),
  {
    fallback: <RouteFallback />
  }
);

const MizoMusicFestivalPolicy = loadable(
  () =>
    import(
      /* webpackChunkName: "Policy" */ '../Pages/MizoMusicFestivalPolicy/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const NipponIndiaMutualFundpoPolicy = loadable(
  () =>
    import(
      /* webpackChunkName: "Policy" */ '../Pages/NipponIndiaMutualFundpolicy/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const LazyNipponIndiaMutualFundLivePolls = loadable(
  () =>
    import(
      /* webpackChunkName: "vine_app_links" */ '../Pages/NipponIndiaMutualFundLivePoll/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const LazyNipponIndiaMutualFundAppLinks = loadable(
  () =>
    import(
      /* webpackChunkName: "vine_app_links" */ '../Pages/NipponIndiaMutualFundApp/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const UnstoppableNAMIAppLinks = loadable(
  () =>
    import(
      /* webpackChunkName: "vine_app_links" */ '../Pages/UnstoppableNAMIApp/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const LazyALGlobalConferenceAppLinks = loadable(
  () =>
    import(
      /* webpackChunkName: "vine_app_links" */ '../Pages/ALGlobalConferenceApp/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const LazyMspireAppLinks = loadable(
  () =>
    import(/* webpackChunkName: "vine_app_links" */ '../Pages/MspireApp/index'),
  {
    fallback: <RouteFallback />
  }
);

const LazyMspire2025AppLinks = loadable(
  () =>
    import(
      /* webpackChunkName: "vine_app_links" */ '../Pages/Mspire2025App/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const LazyMspire2026AppLinks = loadable(
  () =>
    import(
      /* webpackChunkName: "vine_app_links" */ '../Pages/Mspire2026App/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const Maa10Policy = loadable(
  () => import(/* webpackChunkName: "Policy" */ '../Pages/Maa10Policy/index'),
  {
    fallback: <RouteFallback />
  }
);

const ALGlobalConferencePolicy = loadable(
  () =>
    import(
      /* webpackChunkName: "Policy" */ '../Pages/ALGlobalConferencePolicy/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const ALConferencesPolicy = loadable(
  () =>
    import(
      /* webpackChunkName: "Policy" */ '../Pages/ALGlobalConference2025PrivacyPolicy/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const EemaPolicy = loadable(
  () => import(/* webpackChunkName: "Policy" */ '../Pages/EemaPolicy/index'),
  {
    fallback: <RouteFallback />
  }
);

// const CarlsbergPolicy = loadable(
//   () =>
//     import(/* webpackChunkName: "Policy" */ '../Pages/carlsbergPolicy/index'),
//   {
//     fallback: <RouteFallback />
//   }
// );

const ThryvifiedPolicy = loadable(
  () =>
    import(/* webpackChunkName: "Policy" */ '../Pages/ThryvifiedPolicy/index'),
  {
    fallback: <RouteFallback />
  }
);

const ThryvifiedAppLinks = loadable(
  () => import(/* webpackChunkName: "Policy" */ '../Pages/ThryvifiedApp/index'),
  {
    fallback: <RouteFallback />
  }
);

const LMAIAppLinks = loadable(
  () => import(/* webpackChunkName: "Policy" */ '../Pages/LmaiApp/index'),
  {
    fallback: <RouteFallback />
  }
);

const APWeddingPolicy = loadable(
  () =>
    import(/* webpackChunkName: "Policy" */ '../Pages/APWeddingPolicy/index'),
  {
    fallback: <RouteFallback />
  }
);

const EILPolicy = loadable(
  () => import(/* webpackChunkName: "Policy" */ '../Pages/eilPolicy/index'),
  {
    fallback: <RouteFallback />
  }
);

const IBGPolicy = loadable(
  () => import(/* webpackChunkName: "Policy" */ '../Pages/ibgPolicy/index'),
  {
    fallback: <RouteFallback />
  }
);

const LakshyaPolicy = loadable(
  () => import(/* webpackChunkName: "Policy" */ '../Pages/LakshyaPolicy/index'),
  {
    fallback: <RouteFallback />
  }
);

const VBYLDPolicy = loadable(
  () => import(/* webpackChunkName: "Policy" */ '../Pages/VbyldPolicy/index'),
  {
    fallback: <RouteFallback />
  }
);

const ICDMAIPolicy = loadable(
  () => import(/* webpackChunkName: "Policy" */ '../Pages/IcdmaiPolicy/index'),
  {
    fallback: <RouteFallback />
  }
);

const NIRVAANPolicy = loadable(
  () => import(/* webpackChunkName: "Policy" */ '../Pages/NirvaanPolicy/index'),
  {
    fallback: <RouteFallback />
  }
);

const LAKSHYA26Policy = loadable(
  () =>
    import(/* webpackChunkName: "Policy" */ '../Pages/Lakshya26Policy/index'),
  {
    fallback: <RouteFallback />
  }
);

const IIFTCCONCLAVE2026Policy = loadable(
  () =>
    import(
      /* webpackChunkName: "Policy" */ '../Pages/IIFTCCONCLAVE2026Policy/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const MintlabsPolicy = loadable(
  () =>
    import(/* webpackChunkName: "Policy" */ '../Pages/MintlabsPolicy/index'),
  {
    fallback: <RouteFallback />
  }
);

const BusinessConclavePolicy = loadable(
  () =>
    import(/* webpackChunkName: "Policy" */ '../Pages/BusinessConclave/index'),
  {
    fallback: <RouteFallback />
  }
);

const CorporateSpherePolicy = loadable(
  () =>
    import(
      /* webpackChunkName: "Policy" */ '../Pages/CorporateSpherePolicy/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const BusinessBridgePolicy = loadable(
  () =>
    import(
      /* webpackChunkName: "Policy" */ '../Pages/BusinessBridgePolicy/index'
    ),
  {
    fallback: <RouteFallback />
  }
);
const UnstoppableNAMIPolicy = loadable(
  () =>
    import(
      /* webpackChunkName: "Policy" */ '../Pages/UnstoppableNAMIPolicy/index'
    ),
  {
    fallback: <RouteFallback />
  }
);
const ExecutiveLinkPolicy = loadable(
  () =>
    import(
      /* webpackChunkName: "Policy" */ '../Pages/ExecutiveLinkPolicy/index'
    ),
  {
    fallback: <RouteFallback />
  }
);
const CorporateVistaPolicy = loadable(
  () =>
    import(
      /* webpackChunkName: "Policy" */ '../Pages/CorporateVistaPolicy/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const ExecutiveEdgePolicy = loadable(
  () =>
    import(
      /* webpackChunkName: "Policy" */ '../Pages/ExecutiveEdgePolicy/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const TresIndiaPolicy = loadable(
  () =>
    import(/* webpackChunkName: "Policy" */ '../Pages/TresIndiaPolicy/index'),
  {
    fallback: <RouteFallback />
  }
);

const BWFPolicy = loadable(
  () => import(/* webpackChunkName: "Policy" */ '../Pages/BWFPolicy/index'),
  {
    fallback: <RouteFallback />
  }
);
const BWFAppLinks = loadable(
  () =>
    import(/* webpackChunkName: "vine_app_links" */ '../Pages/BWFApp/index'),
  {
    fallback: <RouteFallback />
  }
);

const ExecutiveSummitPolicy = loadable(
  () =>
    import(/* webpackChunkName: "Policy" */ '../Pages/ExecutiveSummit/index'),
  {
    fallback: <RouteFallback />
  }
);

const OccasionXpertsPolicy = loadable(
  () =>
    import(/* webpackChunkName: "Policy" */ '../Pages/OccasionXperts/index'),
  {
    fallback: <RouteFallback />
  }
);

const CNWeddingPolicy = loadable(
  () =>
    import(/* webpackChunkName: "Policy" */ '../Pages/CNWeddingPolicy/index'),
  {
    fallback: <RouteFallback />
  }
);

const HSBCPolicy = loadable(
  () => import(/* webpackChunkName: "Policy" */ '../Pages/HSBCPolicy/index'),
  {
    fallback: <RouteFallback />
  }
);

const ConclaveAppLinks = loadable(
  () =>
    import(
      /* webpackChunkName: "vine_app_links" */ '../Pages/212ConclaveApp/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const HSBCAppLinks = loadable(
  () =>
    import(/* webpackChunkName: "vine_app_links" */ '../Pages/HSBCApp/index'),
  {
    fallback: <RouteFallback />
  }
);

const YECPolicy = loadable(
  () => import(/* webpackChunkName: "Policy" */ '../Pages/YECPolicy/index'),
  {
    fallback: <RouteFallback />
  }
);

const ConclavePolicy = loadable(
  () =>
    import(/* webpackChunkName: "Policy" */ '../Pages/212ConclavePolicy/index'),
  {
    fallback: <RouteFallback />
  }
);

const IntegrityChampPolicy = loadable(
  () =>
    import(
      /* webpackChunkName: "Policy" */ '../Pages/IntegrityChampPolicy/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const YECAppLinks = loadable(
  () =>
    import(/* webpackChunkName: "vine_app_links" */ '../Pages/YECApp/index'),
  {
    fallback: <RouteFallback />
  }
);

const VBYLDAppLinks = loadable(
  () =>
    import(/* webpackChunkName: "vine_app_links" */ '../Pages/VbyldApp/index'),
  {
    fallback: <RouteFallback />
  }
);

const LAKSHYA26AppLinks = loadable(
  () =>
    import(
      /* webpackChunkName: "vine_app_links" */ '../Pages/Lakshya26App/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const IIFTCCONCLAVE2026AppLinks = loadable(
  () =>
    import(
      /* webpackChunkName: "vine_app_links" */ '../Pages/IIFTCCONCLAVE2026App/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const TRESINDIAAppLinks = loadable(
  () =>
    import(
      /* webpackChunkName: "vine_app_links" */ '../Pages/TresIndiaApp/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const ICDMAIAppLinks = loadable(
  () =>
    import(/* webpackChunkName: "vine_app_links" */ '../Pages/IcdmaiApp/index'),
  {
    fallback: <RouteFallback />
  }
);

const PolycabAppLinks = loadable(
  () =>
    import(
      /* webpackChunkName: "vine_app_links" */ '../Pages/PolycabApp/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const OccasionXpertsAppLinks = loadable(
  () =>
    import(
      /* webpackChunkName: "vine_app_links" */ '../Pages/OccasionXpertApp/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const ALConferencesAppLink = loadable(
  () =>
    import(
      /* webpackChunkName: "vine_app_links" */ '../Pages/ALConferences2025App/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const SSVMeetPage = loadable(
  () =>
    import(
      /* webpackChunkName: "vine_app_links" */ '../Pages/SSVMEET25SinglePage/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const ConclavePage = loadable(
  () =>
    import(
      /* webpackChunkName: "vine_app_links" */ '../Pages/212ConslaveSinglePage/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const AIAAROCONAppLinks = loadable(
  () => import(/* webpackChunkName: "Policy" */ '../Pages/Aiaarocon2026/index'),
  {
    fallback: <RouteFallback />
  }
);

const AIAAROCONPolicy = loadable(
  () =>
    import(/* webpackChunkName: "Policy" */ '../Pages/AIAAROCONPolicy/index'),
  {
    fallback: <RouteFallback />
  }
);

const DirectorsCut2025AppLinks = loadable(
  () =>
    import(
      /* webpackChunkName: "vine_app_links" */ '../Pages/DirectorsCut2025App/index'
    ),
  {
    fallback: <RouteFallback />
  }
);

const MainRoute = () => (
  <React.Suspense fallback={<RouteFallback />}>
    <Switch>
      <Route path="/" exact component={LazyHome} />
      <Route path="/ViNe" component={LazyVineAppLinks} />
      <Route exact path="/mspire2024/applink" component={LazyMspireAppLinks} />
      <Route path="/AnkushWedsChinmaya/appLink" component={WeddingAppLinks} />
      <Route exact path="/LetLoveFly/appLink" component={LazyLLFAppLinks} />
      <Route exact path="/termsandconditions" component={LazyTOS} />
      <Route exact path="/privacypolicy" component={LazyPolicy} />
      <Route exact path="/frequentlyaskedquestions" component={LazyFAQ} />
      <Route
        path="/playStore"
        exact
        render={(props) => <RedirectPage {...props} url={PLAYSTORE_LINK} />}
      />
      <Route
        path="/appStore"
        exact
        render={(props) => <RedirectPage {...props} url={APPSTORE_LINK} />}
      />
      <Route exact path="/LetLoveFly/privacypolicy" component={LazyLLFPolicy} />
      <Route
        exact
        path="/AsianPaints/privacypolicy"
        component={LazyAsianPaintsPolicy}
      />
      <Route
        exact
        path="/SuperPremiumApplicators/privacypolicy"
        component={LazySuperPremiumApplicatorsPolicy}
      />
      <Route
        exact
        path="/AnkushWedsChinmaya/privacypolicy"
        component={LazyACPolicy}
      />
      <Route exact path="/TMKAMAGIC/privacypolicy" component={LazyTMPolicy} />
      <Route exact path="/TMKAMAGIC/appLink" component={TmKaMagicAppLinks} />
      <Route exact path="/DeleteAccount" component={LazyDeleteAccount} />
      <Route
        exact
        path="/PolycabRefresh/privacypolicy"
        component={LazyPRPolicy}
      />
      <Route exact path="/RidomilGold/privacypolicy" component={LazyRGPolicy} />
      <Route exact path="/POLYCAB/appLink" component={PolycabAppLinks} />
      <Route
        exact
        path="/MizoMusicFestival/privacypolicy"
        component={MizoMusicFestivalPolicy}
      />
      <Route
        exact
        path="/NipponIndiaMutualFund/privacypolicy"
        component={NipponIndiaMutualFundpoPolicy}
      />
      <Route
        exact
        path="/NipponIndiaMutualFund/appLink"
        component={LazyNipponIndiaMutualFundAppLinks}
      />
      <Route
        exact
        path="/NipponIndiaMutualFund/LivePolls"
        component={LazyNipponIndiaMutualFundLivePolls}
      />
      <Route
        exact
        path="/ALGlobalConference/privacypolicy"
        component={ALGlobalConferencePolicy}
      />
      <Route
        exact
        path="/ALConferences/privacypolicy"
        component={ALConferencesPolicy}
      />
      <Route
        exact
        path="/ALConferences/appLink"
        component={ALConferencesAppLink}
      />
      <Route
        exact
        path="/ALGlobalConference/appLink"
        component={LazyALGlobalConferenceAppLinks}
      />
      <Route exact path="/Eema/privacypolicy" component={EemaPolicy} />
      <Route exact path="/EEMA/appLink" component={EemaAppLinks} />

      <Route
        exact
        path="/EILTechnicalConclave2024/privacypolicy"
        component={EILPolicy}
      />
      <Route exact path="/IBGCircle/privacypolicy" component={IBGPolicy} />

      <Route exact path="/Lakshya25/privacypolicy" component={LakshyaPolicy} />
      <Route exact path="/VBYLD2025/privacypolicy" component={VBYLDPolicy} />
      <Route exact path="/VBYLD2025/appLink" component={VBYLDAppLinks} />
      <Route exact path="/ICDMAI/privacypolicy" component={ICDMAIPolicy} />
      <Route exact path="/Nirvaan/privacypolicy" component={NIRVAANPolicy} />
      <Route exact path="/Nirvaan/applink" component={LazyNirvaanAppLinks} />
      <Route
        exact
        path="/Lakshya26/privacypolicy"
        component={LAKSHYA26Policy}
      />
      <Route
        exact
        path="/IIFTCConclave/privacypolicy"
        component={IIFTCCONCLAVE2026Policy}
      />
      <Route exact path="/Mintlabs/privacypolicy" component={MintlabsPolicy} />
      <Route
        exact
        path="/IIFTCConclave/appLink"
        component={IIFTCCONCLAVE2026AppLinks}
      />
      <Route
        exact
        path="/BusinessConclave/privacypolicy"
        component={BusinessConclavePolicy}
      />

      <Route
        exact
        path="/CorporateSphere/privacypolicy"
        component={CorporateSpherePolicy}
      />

      <Route
        exact
        path="/BusinessBridge/privacypolicy"
        component={BusinessBridgePolicy}
      />
      <Route
        exact
        path="/UnstoppableNAMI/privacypolicy"
        component={UnstoppableNAMIPolicy}
      />
      <Route
        exact
        path="/UnstoppableNAMI/appLink"
        component={UnstoppableNAMIAppLinks}
      />
      <Route
        exact
        path="/ExecutiveLink/privacypolicy"
        component={ExecutiveLinkPolicy}
      />
      <Route
        exact
        path="/CorporateVista/privacypolicy"
        component={CorporateVistaPolicy}
      />

      <Route
        exact
        path="/ExecutiveEdge/privacypolicy"
        component={ExecutiveEdgePolicy}
      />

      <Route
        exact
        path="/AIAAROCON2026/privacypolicy"
        component={AIAAROCONPolicy}
      />
      <Route
        exact
        path="/AIAAROCON2026/appLink"
        component={AIAAROCONAppLinks}
      />

      <Route exact path="/BWF/privacypolicy" component={BWFPolicy} />
      <Route exact path="/BWF/appLink" component={BWFAppLinks} />
      <Route
        exact
        path="/TresIndia/privacypolicy"
        component={TresIndiaPolicy}
      />
      <Route exact path="/TresIndia/appLink" component={TRESINDIAAppLinks} />
      <Route
        exact
        path="/ExecutiveSummit/privacypolicy"
        component={ExecutiveSummitPolicy}
      />
      <Route exact path="/Lakshya26/appLink" component={LAKSHYA26AppLinks} />
      <Route
        exact
        path="/DirectorsCut2025/privacypolicy"
        component={CNWeddingPolicy}
      />
      <Route
        exact
        path="/OccasionXperts/appLink"
        component={OccasionXpertsAppLinks}
      />
      <Route
        exact
        path="/OccasionXperts/privacypolicy"
        component={OccasionXpertsPolicy}
      />
      <Route exact path="/ICDMAI/appLink" component={ICDMAIAppLinks} />

      {/* <Route
        exact
        path="/IntegrityChamp/privacypolicy"
        component={CarlsbergPolicy}
      /> */}
      <Route
        exact
        path="/IntegrityChamp/appLink"
        component={IntegrityChampAppLinks}
      />
      <Route
        exact
        path="/DirectorsCut2025/appLink"
        component={DirectorsCut2025AppLinks}
      />
      <Route
        exact
        path="/APWedding/privacypolicy"
        component={APWeddingPolicy}
      />
      <Route
        exact
        path="/VibeWithTheNight/privacypolicy"
        component={VibeWithTheNightPolicy}
      />
      <Route
        exact
        path="/Thryvified2024/privacypolicy"
        component={ThryvifiedPolicy}
      />
      <Route
        exact
        path="/Thryvified2024/appLink"
        component={ThryvifiedAppLinks}
      />
      <Route exact path="/Mspire/privacypolicy" component={MspirePolicy} />
      <Route
        exact
        path="/mspire2025/applink"
        component={LazyMspire2025AppLinks}
      />
      <Route
        exact
        path="/212Conclave/privacypolicy"
        component={ConclavePolicy}
      />
      <Route exact path="/212Conclave/appLink" component={ConclaveAppLinks} />
      <Route exact path="/SSV-MEET-25/privacypolicy" component={HSBCPolicy} />
      <Route exact path="/SSVMEET25/BanarasMemories" component={SSVMeetPage} />
      <Route
        exact
        path="/212Conclave/PostCardMoments"
        component={ConclavePage}
      />
      <Route exact path="/SSV-MEET-25/appLink" component={HSBCAppLinks} />
      <Route exact path="/YEC2024/privacypolicy" component={YECPolicy} />
      <Route exact path="/YEC2024/appLink" component={YECAppLinks} />
      <Route
        exact
        path="/LMAIConference2025/privacypolicy"
        component={LMAIPolicy}
      />
      <Route
        exact
        path="/LMAIConference2025/appLink"
        component={LMAIAppLinks}
      />
      <Route
        exact
        path="/Mspire2025/privacypolicy"
        component={Mspire2025Policy}
      />
      <Route
        exact
        path="/IntegrityChamp/privacypolicy"
        component={IntegrityChampPolicy}
      />
      <Route
        exact
        path="/Mspire2026/privacypolicy"
        component={Mspire2026Policy}
      />
      <Route
        exact
        path="/mspire2026/applink"
        component={LazyMspire2026AppLinks}
      />
      <Route
        exact
        path="/HCCBPartnersMeet2026/privacypolicy"
        component={HCCBPartnersMeet2026Policy}
      />
      <Route
        exact
        path="/GrowthCode/privacypolicy"
        component={GrowthCodePolicy}
      />
      <Route exact path="/enGen/applink" component={LazyenGenAppLinks} />
      <Route exact path="/enGen/privacypolicy" component={enGenPolicy} />
      <Route
        exact
        path="/HCCBPartnersMeet2026/applink"
        component={LazyHCCBPartnersMeet2026AppLinks}
      />
      <Route
        exact
        path="/GrowthCode/applink"
        component={LazyGrowthCodeAppLinks}
      />
      <Route
        exact
        path="/RutwikTanvi/privacypolicy"
        component={RutwikTanviPolicy}
      />
      <Route
        exact
        path="/TanviRutwik/privacypolicy"
        component={TanviRutwikPolicy}
      />
      <Route
        exact
        path="/TanviRutwik/applink"
        component={LazyRutwikTanviAppLinks}
      />
      <Route
        exact
        path="/RutwikTanvi/applink"
        component={LazyRutwikTanviAppLinks}
      />
      <Route
        exact
        path="/RoadToPhuket/privacypolicy"
        component={RoadToPhuketPolicy}
      />
      <Route
        exact
        path="/RoadToPhuket/applink"
        component={LazyRoadToPhuketAppLinks}
      />
      <Route
        exact
        path="/WellnessExpedition/privacypolicy"
        component={WellnessExpeditionPolicy}
      />
      <Route
        exact
        path="/WellnessExpedition/applink"
        component={LazyWellnessExpeditionAppLinks}
      />
      <Route
        exact
        path="/Thryvified2026/privacypolicy"
        component={Thryvified2026Policy}
      />
      <Route
        exact
        path="/TigerAnalytics/privacypolicy"
        component={TigerAnalyticsPolicy}
      />
      <Route
        exact
        path="/TigerAnalytics/applink"
        component={LazyTigerAnalyticsAppLinks}
      />
      <Route
        exact
        path="/APMIAnnualConference2026/privacypolicy"
        component={APMIAnnualConference2026Policy}
      />
      <Route
        exact
        path="/APMI/applink"
        component={LazyAPMIAnnualConference2026AppLinks}
      />
      <Route
        exact
        path="/JharokhaSangam/privacypolicy"
        component={JharokhaSangamPolicy}
      />
      <Route
        exact
        path="/JharokhaSangam/applink"
        component={LazyJharokhaSangamAppLinks}
      />
      <Route
        exact
        path="/GCOOCONCLAVE2026/privacypolicy"
        component={GCOOCONCLAVE2026Policy}
      />
      <Route
        exact
        path="/GCOOCONCLAVE2026/applink"
        component={LazyGCOOCONCLAVE2026AppLinks}
      />
      <Route exact path="/SAREX26/privacypolicy" component={SAREX26Policy} />
      <Route exact path="/SAREX26/applink" component={LazySAREX26AppLinks} />
      <Route exact path="/GSM26/privacypolicy" component={GSM26Policy} />
      <Route exact path="/TAFEGSM2026/applink" component={LazyGSM26AppLinks} />
      <Route exact path="/Maa10/privacypolicy" component={Maa10Policy} />
      <Route
        exact
        path="/RedKkarpetEvents/privacypolicy"
        component={RedKkarpetEventsPolicy}
      />
      <Route
        exact
        path="/RedKkarpetEvents/applink"
        component={RedKkarpetEventsAppLinks}
      />
    </Switch>
  </React.Suspense>
);

export default MainRoute;
